<template>
  <div style="padding: 20px">
    <div class="handle-box" style="display:flex;flex-wrap: wrap;margin-bottom: 20px">
      <el-button type="primary" style="margin-right: 10px" @click="insertDialog =true">新增</el-button>
      <el-input style="width: 160px" v-model="query.keyword" placeholder="请输入名称" class="margin-right"></el-input>
      <el-input style="width: 160px;margin: 0 10px" v-model="query.coachName" placeholder="请输入创建人" class="margin-right"></el-input>
      <el-select placeholder="请选择合同类型" v-model="query.type" style="width: 160px" clearable>
        <el-option v-for="(item,i) in typeList" :key="i" :value="item.dictType" :label="item.dictValue"></el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 10px" @click="page">搜索</el-button>
    </div>
    <el-table
        :data="tableData"
        height="590px"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header">
      <el-table-column  width="100" label="ID" align="center" show-overflow-tooltip prop="id" />
      <el-table-column label="合同名称" align="center" show-overflow-tooltip prop="title"/>
      <el-table-column  width="100" label="合同类型" align="center" show-overflow-tooltip prop="dictType"/>
      <el-table-column width="170" label="到期时间" align="center" show-overflow-tooltip prop="expirationTime"/>
      <el-table-column  width="100" label="附件" align="center" show-overflow-tooltip prop="title">
        <template #default="scope">
          <el-link v-if="scope.row.attachmentUrl" style="color: #1da1f2"
              :href="scope.row.attachmentUrl"
              target="_blank"
              underline="hover">
            查看文件
          </el-link>
          <span v-else style="color: #909399">未上传</span>
        </template>
      </el-table-column>


      <el-table-column label="可视老师" align="center">
        <template #default="scope">
          <el-select  placeholder="可视老师" style="width: 140px">
            <el-option
                v-for="item in scope.row.looks"
                :key="item.id"
                :label="item.coachName"
                :value="item.id"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="提醒老师" align="center">
        <template #default="scope">
          <el-select  placeholder="提醒老师" style="width: 140px">
            <el-option
                v-for="item in scope.row.reminders"
                :key="item.id"
                :label="item.coachName"
                :value="item.id"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column width="170" label="提醒日期" align="center" show-overflow-tooltip prop="deadlineTime"/>
      <el-table-column label="备注" align="center" show-overflow-tooltip prop="notes" />
      <el-table-column label="创建老师" align="center" show-overflow-tooltip prop="reminderCoachName" />
      <el-table-column label="添加时间" align="center" show-overflow-tooltip prop="addTime" />
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template #default="scope">
          <el-button text type="primary" style="width: 14px;" size="small" @click="updateItem(scope.row)">编辑</el-button>
          <el-popconfirm @confirm="deleteEventReminder(scope.row.id)" title="确定要删除吗？">
            <template #reference>
              <el-button text type="primary" style="width: 14px;color: red" size="small">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="sizes, prev, pager, next, total"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :page-sizes="[10, 20, 30, 40]"
          :total="query.pageTotal"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
      ></el-pagination>
    </div>
    <el-dialog v-model="insertDialog" :title="updateDialog == true ? '更新合同':'新增合同' " width="980">
      <div>
        <el-form :model="insertData" ref="insertRules" label-width="120px" class="demo-ruleForm">
          <div >
            <el-row>
              <el-col :span="7">
                <el-form-item label="合同名称" prop="title" :rules="{ required: true, message: '请输入', trigger: 'blur'}">
                  <el-input style="width: 160px" v-model="insertData.title" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="合同类型" prop="type" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
                  <el-select placeholder="请选择合同类型" v-model="insertData.type" style="width: 160px" clearable>
                    <el-option v-for="(item,i) in typeList" :key="i" :value="Number(item.dictType)" :label="item.dictValue"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="到期时间">
                  <el-date-picker type="date" style="width:160px" value-format="YYYY-MM-DD" v-model="insertData.expirationTime"
                                  placeholder="请选择">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <el-form-item label="可视老师">
                    <el-cascader class="el-cascader__tags" collapse-tags style="width: 160px" ref="looks"
                                 :options="deptUserTree" v-model="insertData.looks"
                                 :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="提醒老师">
                    <el-cascader  class="el-cascader__tags" collapse-tags style="width: 160px"  ref="reminders"
                                 :options="deptUserTree" v-model="insertData.reminders"
                                 :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="提醒时间" prop="deadlineTime" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
                  <el-date-picker type="date" style="width:160px" value-format="YYYY-MM-DD" v-model="insertData.deadlineTime"
                                  placeholder="请选择">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="margin: 0 0 10px 100px;color: red;height: 20px">
              <span v-if="insertData.deadlineTime">{{insertData.deadlineTime}}的前14天、7天、3天、1天，系统将会通过公众号形式通知提醒老师。</span>
            </div>

            <el-row>
              <el-col :span="14">
                <el-form-item label="附件">
                  <el-upload
                      style="width: 600px"
                      drag :limit="1" :on-remove="removeFile"
                      :http-request="response => file(response,index)">
                    <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                    <div class="el-upload__text">
                      将文件拖到此处，或<em>点击上传</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="21">
                <el-form-item label="备注">
                  <el-input
                      v-model="insertData.notes"
                      :rows="2"
                      type="textarea"
                      placeholder="如：文件位置、特殊说明、注意事项等..."/>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="insertDialog = false">取 消</el-button>
          <el-button type="primary" @click="insert">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {deptAndCoachList} from "../../api/dept";
import {selectDictByType} from "../../api/dict";
import { add,getEventReminderList,deleteEventReminder,uploadFile,update } from "../../api/eventReminder";
export default {
  name: "ExpirationReminder",
  data() {
    return {
      query:{
        date:null,
        keyword:"",
        pageIndex: 1,
        pageSize: 13,
        pageTotal:0
      },
      tableData:[],
      insertDialog:false,
      insertData:{
        title:null,
        attachmentUrl:null,
        deadlineTime:null,
        expirationTime:null,
        notes:"",
        type:null,
        reminders:[],
        looks:[],
      },
      deptUserTree:[],
      typeList:[],
      updateDialog:false,
    }
  },
  methods: {
    handlePageChange(index){
      this.query.pageIndex=index;
      this.page();
    },
    handlePageSizeChange(size){
      this.query.pageSize=size;
      this.page();
    },
    removeFile(){
      this.insertData.attachmentUrl = null;
      this.insertData.attachmentUrl = null;

    },
    file(file){
      const data = new FormData()
      data.append('multipartFile', file.file)
      data.append('flag', 'group')
      data.append('fileName', file.file.name)
      uploadFile(data).then(val=>{
        if (val) {
          this.insertData.attachmentUrl = val;
          this.insertData.attachmentUrl = val;
          this.$message.success("文件上传成功！");
        } else {
          this.$message.error("文件上传失败！");
        }
      })
    },
    updateItem(item){
      let looks = []
      item.looks.forEach(coach=>{
        looks.push(coach.coachId);
      })
      let reminders = []
      item.reminders.forEach(coach=>{
        reminders.push(coach.coachId);
      })
      this.insertData = item;
      this.insertData.looks = looks;
      this.insertData.reminders = reminders;
      this.updateDialog = true;
      this.insertDialog = true;
    },
    changeCoach(id){
      this.insertData.coach = this.coachList.find(item => item.coachid === id);
    },
    deleteEventReminder(id){
      deleteEventReminder(id).then(val=>{
        if (val.code == 200) {
          this.page();
          this.$message.success("删除成功！");
        } else {
          this.$message.error("删除失败！");
        }
      })
    },
    page(){
      getEventReminderList(this.query).then(val=>{
        if (val.code == 200){
          this.query.pageTotal = val.data.total;
          this.tableData = val.data.records;
        }
      })
    },
    insert(){
      this.$refs['insertRules'].validate(async (valid) => {
        if (!valid){return;}
        let data = JSON.parse(JSON.stringify(this.insertData));
        let looks = [];
        const checkedNodes = this.$refs.looks.getCheckedNodes();
        checkedNodes.forEach((node) => {
          if (node.data.type == 1){//只保留用户不保留部门
            looks.push({coachId: node.value,coachName:node.label})
          }
        });
        data.looks = looks;
        let reminders = [];
        const checkedNodes2 = this.$refs.reminders.getCheckedNodes();
        checkedNodes2.forEach((node) => {
          if (node.data.type == 1){//只保留用户不保留部门
            reminders.push({coachId: node.value,coachName:node.label})
          }
        });
        data.reminders = reminders;
        if (this.updateDialog == true){
          update(data).then(val=>{
            if (val.code == 200) {
              this.page();
              this.insertDialog = false;
              this.updateDialog = false;
              this.$message.success("更新成功！");
            } else {
              this.$message.error("更新失败！");
            }
          })
          return;
        }else {
          add(data).then(val=>{
            if (val.code == 200) {
              this.page();
              this.insertDialog = false;
              this.updateDialog = false;
              this.$message.success("新增成功！");
            } else {
              this.$message.error("新增失败！");
            }
          })
        }
      })
    }
  },
  created() {
    this.page();
    selectDictByType("eventReminderTypes").then(val=>{
      if (val.code === 200) {
        this.typeList = val.data
      }
    })
    deptAndCoachList().then(val=>{
      if (val.code == 200){
        this.deptUserTree=val.data;
      }
    })
  }
}
</script>

<style scoped>
::v-deep .el-cascader__tags{
  width: 68%;
  flex-wrap: nowrap;
}
</style>